import React, { useCallback, useEffect, useRef, useState } from 'react';

import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import Page from 'components/Page';
import SubHeader from 'components/SubHeader';

import Button from '@mui/material/Button';

import useGlobalState from 'actions';
import services from 'services';
import utils from 'utils';
import useOnScreen from 'utils/useOnScreen';

import './index.scss';

const AgreementLetterPage = () => {
  const [
    globalState,
    {
      openNotification,
      closeNotification,
      openLoadingOverlay,
      closeLoadingOverlay,
      getResponseError,
    },
  ] = useGlobalState();
  const history = useHistory();
  const [htmlContent, setHtmlContent] = useState(null);
  const bottomRef = useRef(null);
  const isAtBottom = useOnScreen(bottomRef);
  const lsRedirectPage = localStorage.getItem('redirectPage') || '';
  const isReadOnly = lsRedirectPage.includes('loan_history');

  const showErrorNotification = useCallback(
    (msg) => {
      openNotification(msg);
      setTimeout(() => {
        closeNotification();
      }, globalState.notificationDelayTime);
    },
    [closeNotification, globalState.notificationDelayTime, openNotification],
  );

  const handleClickBack = () => {
    services.ga.sendEventsToGA('Button', 'Click', 'id_signtnc_back');
    history.goBack();
    localStorage.removeItem('redirectPage');
  };

  const getAgreementLetterContent = useCallback(() => {
    services.loan.getApplicationStatus(
      (res) => {
        const loanXid = res?.data?.loan?.loan_xid;
        if (!loanXid) return;

        const payload = {
          loan_xid: loanXid,
        };
        services.ga.sendEventsToGA('Page', 'Display', 'id_signtnc_default');
        openLoadingOverlay();
        services.loan.getAgreementLetter(
          payload,
          (response) => {
            if (response.data) {
              const letterData = response.data;
              setHtmlContent(letterData.agreement_letter);
            }
            closeLoadingOverlay();
          },
          () => {
            closeLoadingOverlay();
          },
        );
      },
      (error) => {
        showErrorNotification(globalActions.getResponseError(error));
      },
    );
  }, [closeLoadingOverlay, openLoadingOverlay, showErrorNotification]);

  const confirmAgreementLetter = () => {
    services.ga.sendEventsToGA('Button', 'Click', 'id_signdetails_next');
    const payload = {
      feature: 'digital_signature_failover',
    };
    services.privy.checkMobileFeature(
      payload,
      (response) => {
        if (response.content) {
          const payload = {
            feature: 'privy_mode',
          };
          const failover = response.content.active;
          services.privy.checkMobileFeature(
            payload,
            (response) => {
              if (response.content) {
                const privyMode = response.content.active;
                services.loan.getApplicationStatus(
                  (response1) => {
                    if (response1.data) {
                      if (
                        response1.data?.application &&
                        response1.data?.application?.application_status === 190
                      ) {
                        localStorage.setItem(
                          'appStatus',
                          response1.data.application.application_status,
                        );
                        if (
                          response1.data?.loan &&
                          response1.data?.loan?.status >= 210
                        ) {
                          localStorage.setItem(
                            'loan_xid',
                            response1.data.loan.loan_xid,
                          );
                          localStorage.removeItem('redirectPage');
                          if (!failover && privyMode) {
                            history.push('/privy_waiting');
                          } else {
                            history.push('/privy_fail_over');
                          }
                        } else {
                          showErrorNotification(globalState.noLoanXidError);
                        }
                      } else {
                        showErrorNotification(globalState.noLoanXidError);
                      }
                    } else {
                      showErrorNotification(globalState.generalErrorMsg);
                    }
                  },
                  (error) => {
                    showErrorNotification(getResponseError(error));
                  },
                );
              } else {
                showErrorNotification(globalState.generalErrorMsg);
              }
            },
            () => {
              showErrorNotification(globalState.generalErrorMsg);
            },
          );
        }
      },
      () => {
        showErrorNotification(globalState.generalErrorMsg);
      },
    );
  };

  useEffect(() => {
    const hasToken = utils.store.get('token');
    if (!hasToken) {
      history.push('/login');
    } else {
      getAgreementLetterContent();
    }
  }, [getAgreementLetterContent, history]);

  return (
    <>
      <Helmet>
        <title>JULO - Surat Perjanjian Peminjaman</title>
      </Helmet>
      <Page useHeader={true}>
        <SubHeader title='Surat Perjanjian' onBackClick={handleClickBack} />
        <div className='center-align-agreement-div'>
          <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
          <span ref={bottomRef} />
        </div>
        {!isReadOnly && (
          <div className='footer-action'>
            <Button
              variant='contained'
              color='primary'
              onClick={confirmAgreementLetter}
              disabled={!isAtBottom}
              fullWidth
            >
              Tanda Tangan Elektronik
            </Button>
          </div>
        )}
      </Page>
    </>
  );
};

export default AgreementLetterPage;
